export const LOCALES = ['fa', 'en', 'de', 'ar'] as const
export type Locale = (typeof LOCALES)[number]

export const LOCALE_META: Record<
  Locale,
  { label: string; nativeLabel: string; dir: 'rtl' | 'ltr'; numberLocale: string }
> = {
  fa: { label: 'Persian', nativeLabel: 'فارسی', dir: 'rtl', numberLocale: 'fa-IR' },
  en: { label: 'English', nativeLabel: 'English', dir: 'ltr', numberLocale: 'en-US' },
  de: { label: 'German', nativeLabel: 'Deutsch', dir: 'ltr', numberLocale: 'de-DE' },
  ar: { label: 'Arabic', nativeLabel: 'العربية', dir: 'rtl', numberLocale: 'ar-SA' },
}

export const LOCALE_STORAGE_KEY = 'sisil_locale'
/** Legacy key from the Fluky brand rename; migrated on first read. */
export const LEGACY_LOCALE_STORAGE_KEY = 'fluky_locale'

export function isLocale(value: string | null | undefined): value is Locale {
  return !!value && (LOCALES as readonly string[]).includes(value)
}

/** Map Telegram language_code → app locale. */
export function localeFromTelegram(code?: string | null): Locale | null {
  if (!code) return null
  const base = code.toLowerCase().split('-')[0]
  if (base === 'fa' || base === 'per') return 'fa'
  if (base === 'en') return 'en'
  if (base === 'de') return 'de'
  if (base === 'ar') return 'ar'
  return null
}
